module.exports = __webpack_public_path__ + "img/35.d1732b0d.png";